/* RK Gem Collection, Explore by Gems High Jewellery pages.
   The scroll reveals are handled by the global assets/rk-reveal.js (.rk-reveal -> .is-visible),
   incl. the pure-CSS --no-slide / --soft variants. Hero/banner video autoplays natively
   (autoplay muted loop playsinline). JS here: (1) keeps --rk-header-h synced to the live
   header bottom so any sticky offsets stay correct; (2) adds Graff-style prev/next arrows to
   the yellow "Art of Perfection" carousel (progressive enhancement, native scroll without JS). */
(function () {
  function headerEl() {
    return document.querySelector('.header-wrapper')
      || document.querySelector('.section-header')
      || document.querySelector('.shopify-section-group-header-group')
      || document.querySelector('.header');
  }
  var lastHeaderH = -1;
  function setHeaderVar() {
    var h = headerEl();
    if (!h) return;
    var b = Math.round(h.getBoundingClientRect().bottom);
    if (b !== lastHeaderH) {
      lastHeaderH = b;
      document.documentElement.style.setProperty('--rk-header-h', b + 'px');
    }
  }

  /* ---------- Carousel arrows (yellow "Art of Perfection" cropped-to-side carousel) ---------- */
  function makeArrow(kind) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rk-gem__carousel-arrow rk-gem__carousel-arrow--' + kind;
    b.setAttribute('aria-label', kind === 'prev' ? 'Previous' : 'Next');
    var d = kind === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
    return b;
  }

  function initCarousel(row) {
    if (row.closest('.rk-gem__carousel')) return; // already enhanced
    var wrap = document.createElement('div');
    wrap.className = 'rk-gem__carousel';
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);
    var prev = makeArrow('prev');
    var next = makeArrow('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function dir() { return document.documentElement.dir === 'rtl' ? -1 : 1; }
    function step() {
      var cells = row.querySelectorAll('.rk-gem__grid-cell');
      if (cells.length > 1) {
        return cells[1].getBoundingClientRect().left - cells[0].getBoundingClientRect().left;
      }
      if (cells.length === 1) return cells[0].getBoundingClientRect().width + 25;
      return Math.round(row.clientWidth * 0.5);
    }
    prev.addEventListener('click', function () { row.scrollBy({ left: -step() * dir(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { row.scrollBy({ left: step() * dir(), behavior: 'smooth' }); });

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      var sl = Math.abs(row.scrollLeft);
      var atStart = sl <= 1;
      var atEnd = sl >= max - 1;
      prev.classList.toggle('is-off', atStart);
      next.classList.toggle('is-off', atEnd);
      prev.setAttribute('aria-hidden', atStart ? 'true' : 'false');
      next.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
      prev.tabIndex = atStart ? -1 : 0;
      next.tabIndex = atEnd ? -1 : 0;
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initCarousels() {
    var rows = document.querySelectorAll(
      '.rk-gem--yd .rk-gem__grid--4 .rk-gem__grid-row, ' +
      '.rk-gem--em .rk-gem__grid--3 .rk-gem__grid-row, ' +
      '.rk-gem--sa .rk-gem__grid--4 .rk-gem__grid-row, ' +
      '.rk-gem--ru .rk-gem__grid--3 .rk-gem__grid-row'
    );
    for (var i = 0; i < rows.length; i++) initCarousel(rows[i]);
  }

  /* ---------- High Jewellery sub-nav (collapse/expand + carousel arrow) ---------- */
  function initSubnav() {
    var nav = document.querySelector('[data-rk-hj-subnav]');
    if (!nav || nav.dataset.rkInit) return;
    nav.dataset.rkInit = '1';
    var toggle = nav.querySelector('[data-rk-hj-toggle]');
    var track = nav.querySelector('[data-rk-hj-track]');
    var next = nav.querySelector('[data-rk-hj-next]');
    var prev = nav.querySelector('[data-rk-hj-prev]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) setTimeout(updateArrows, 50);
      });
    }
    function step() {
      var card = track && track.querySelector('.rk-hj-subnav__card');
      return card ? Math.round(card.getBoundingClientRect().width) + 25 : 400;
    }
    function setOff(btn, off) {
      if (!btn) return;
      btn.classList.toggle('is-off', off);
      btn.tabIndex = off ? -1 : 0;
      btn.setAttribute('aria-hidden', off ? 'true' : 'false');
    }
    function updateArrows() {
      if (!track) return;
      var max = track.scrollWidth - track.clientWidth;
      var sl = track.scrollLeft;
      /* prev appears ONLY after the carousel is scrolled forward. The resting start is
         non-zero (scroll-snap + track padding), so use a tolerant threshold below one card-step. */
      setOff(prev, sl <= 48);
      setOff(next, max <= 1 || sl >= max - 2);
    }
    if (next && track) {
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    }
    if (prev && track) {
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    }
    if (track) {
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
    }
  }

  function init() {
    if (!document.querySelector('[data-rk-gem]')) return;
    setHeaderVar();
    initCarousels();
    initSubnav();
    window.addEventListener('scroll', setHeaderVar, { passive: true });
    window.addEventListener('resize', setHeaderVar, { passive: true });
    window.addEventListener('load', setHeaderVar, { passive: true });
    document.addEventListener('shopify:section:load', function () {
      setHeaderVar();
      initCarousels();
      initSubnav();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
